export const fullName = 'Brilliance Labs';
export const ensign = 'bl&gt;';
export const shortName = 'bl';
